





































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Session from '@/app/module/session'
import Loading from '@/app/components/Common/Loading.vue'
import Local from '@/app/module/local'
/* api */
import imageApi from '@/app/model/api/getImageApi'

@Component({
  components: {
    Loading
  }
})
export default class GraphImageModal extends Vue {
  private slide: number = 0
  private thumbnailData: any[] = []
  private imgDate: string = ''
  private imgDisplayDate: string = ''
  private showImgLoading: boolean = true
  private defaultImage: any = '/img/ico_cultivation2.0dd21bea.png'
  private noImage: any = require('@/assets/img/no_image.svg')
  private fieldId = ''
  private plantingId = ''
  private userType = parseInt(Local.getUserType()!)

  private get changeMainImg (): any {
    return this.slide
  }

  private get showImgModal (): any {
    return this.$store.state.setFlagState.imgFlag
  }

  @Watch('showImgModal')
  onChangeModal (flag: boolean) {
    if (flag) {
      this.fieldId = this.$route.params.field_id
      this.plantingId = Session.getPlantingId()!

      this.imgDate = this.$store.state.fieldDetailsState.imgDate
      let year = String(this.imgDate).slice(0, 4)
      let month = String(this.imgDate).slice(4, 6)
      let day = String(this.imgDate).slice(6)
      this.imgDisplayDate = year + '年' + month + '月' + day + '日'

      this.imageRecods()
    } else {
      this.thumbnailData = []
    }
  }

  private showMainImg (id: any) {
    this.$store.commit('fieldDetailsState/setMainImgId', id)
    this.$store.commit('setFlagState/setMainImgFlag', true)
  }

  private imageRecods () {
    const imageData = JSON.parse(Session.getImageRecords()!)
    for (let i in imageData) {
      if (imageData[i].record_date === this.imgDate && (imageData[i].crop_image_ids).lenght !== 0) {
        this.getThumbnailImg(imageData[i].crop_image_ids)
      }
    }
  }

  private getThumbnailImg (ids: any) {
    (async () => {
      this.showImgLoading = true
      const imgType = 'thumbnail'
      const imagePath = []

      for (let j in ids) {
        let imgId = ids[j]
        let body: any = {
          crop_image_id: imgId,
          type: imgType
        }
        const result = await imageApi.getImageData(body)
        let img = result
        imagePath.push({ src: img, id: imgId })
      }
      this.thumbnailData = imagePath
      this.showImgLoading = false
    })()
  }

  private closeModal () {
    this.$store.commit('setFlagState/setImgFlag', false)
    this.$emit('close-modal')
  }
}
